import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
// import { DashboardComponent } from './components/dashboard/dashboard.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AuthGuard } from './shared/auth/auth-guard';
import { AccountInformationComponent } from './shared/components/account-information/account-information.component';
import { UserAdministrationComponent } from '@shared/components/user-administration/user-administration.component';
import { SearchComponent } from './components/search/search.component';
import { ReportsComponent } from './components/reports/reports.component';
import { PublicComplaintComponent } from './components/public-complaint/public-complaint.component';
import { HelpComponent, RedirectGuard } from './components/help/help.component';
import { AccessibilityNoticeComponent } from './components/public-complaint/accessibilityNotice/accessibilityNotice.component';
// import { PrintBusinessComponent } from './components/printer/printBusiness/printBusiness.component';
// import { PrinterComponent } from './components/printer/printer.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      {
        path: 'help', canActivate: [RedirectGuard],
        component: RedirectGuard,
        data: {externalUrl: 'assets/WEMSUserManual.pdf' , target: '_blank'//}
          // externalUrl: 'https://www.oregon.gov/oha/PH/DISEASESCONDITIONS/CHRONICDISEASE/HPCDPCONNECTION/TOBACCO/Documents/WEMSCountyUserManualRevisedDecember2018.pdf'
        }
      },

      {
        path: 'mainMenu', canActivate: [AuthGuard],
        loadChildren: () => import('./components/mainMenu/mainMenu.module').then(m => m.MainMenuModule)
      },
      {
        path: 'reports', canActivate: [AuthGuard],
        loadChildren: () => import('./components/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'business', canActivate: [AuthGuard],
        loadChildren: () => import('./components/business/business.module').then(m => m.BusinessModule)
      },
      {
        path: 'complaint', canActivate: [AuthGuard],
        loadChildren: () => import('./components/complaint/complaint.module').then(m => m.ComplaintModule)
      },
      {
        path: 'admin', canActivate: [AuthGuard],
        loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule)
      },
      { path: 'search', component: SearchComponent, canActivate: [AuthGuard] },
      { path: 'account-information', component: AccountInformationComponent, canActivate: [AuthGuard] },
      { path: 'welcome', component: WelcomeComponent },
      {
        path: 'sessions',
        loadChildren: () => import('./shared/components/sessions/sessions.module').then(m => m.SessionsModule)
      },
      {
        path: "user-management",
        component: UserAdministrationComponent,
        canActivate: [AuthGuard]
      }
      // {
      //   path: 'print',
      //   component: PrinterComponent,
      //   outlet: 'print', // Use the 'print' named outlet
      //   children: [
      //     { path: 'business/:id', component: PrintBusinessComponent }
      //   ]
      // }
    ],
  },
  { path: "complaints", component: PublicComplaintComponent },
  { path: "accessibilityNotice", component: AccessibilityNoticeComponent },
  { path: '**', redirectTo: 'complaints' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled"
    })
  ],
  exports: [RouterModule],
  declarations: [
  ]
})
export class RoutesRoutingModule { }
